export default __webpack_public_path__ + "static/media/484.0da900d4.png";